<template>
<div>

<template v-if="!sectiondata">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="sectiondata">


<div class="sections pt-6 pb-6" >
<hr>  

<BeyzayaOzelSubsection v-for="section in sectiondata.childsections" :section="section" ></BeyzayaOzelSubsection>
</div> 

<div class="inputfields pt-2"  v-if="sectiondata.inputfields.length>0">

<CustomInputfield  v-for="item in sectiondata.inputfields" :data="item" @click="showInputfield(item)"></CustomInputfield>
</div>




</template>


</div>
</template>

<script>
import BeyzayaOzelSubsection from "./BeyzayaOzelSubsection"
export default {

  name: 'BeyzayaOzelSection',
  components:{BeyzayaOzelSubsection},
  props:["section"],
  data () {
    return {
    	data:null,
    	loading:false,
      	sectiondata:null,
    }
  },
  mounted()
  {
  	this.getData()
  },
  computed:{
    sectionname()
    {      
      
      return this.getTheTranslation(this.sectiondata.section,"translation")
      
    },

    sectiondescription()
    {
      return this.getTheTranslation(this.sectiondata.section,"description")
      
    },
    inputfields_updating()
    {
      return this.$store.state.evaluation.inputfields_updating
    }
  },
  watch:{
    inputfields_updating(newval,oldval)
    {
      if(!newval)
      {
        this.getData()
      }
    }
  },
  methods:{
  	showInputfield(item)
  	{
  		console.log(item)
  	},
  	async getData()
    {
        await this.$store.dispatch('evaluation/setSectionLoading',true)
        let data = await this.arrangeAuditSectionInputfields(this.section.id)
        await this.$store.dispatch('evaluation/setSectionLoading',false)
        this.sectiondata = await data
    }
  },
}
</script>

<style lang="css" scoped>
</style>